import React from 'react'
import FacetFilterLocation from 'ui-shared/Facets/Wrappers/FacetFilterLocation'
import FacetTag from 'ui-shared/Facets/Wrappers/FacetTag'
import FacetMultiSelect from '../BaseComponents/FacetMultiSelect'

const LocationFacetSection: React.FC = () => {
  return (
    <>
      <FacetTag />
      <FacetFilterLocation />
      <FacetMultiSelect
        source="eventTypeFacet"
        facetCategory="productFilter"
        filterGroup="EventType"
      />
    </>
  )
}

export default LocationFacetSection
